import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IWastyCarrier} from "../../../../../../utils/interfaces/special_wasty/wasty_carrier/IWastyCarrier";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";


const useApiGetWastyRecipients = (): UseQueryResult<IWastyCarrier[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IWastyCarrier[]> {
        try {
            const response = await get(`/api/company/${company_token}/special_wasty/wasty_recipient`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWastyRecipients"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetWastyRecipients